'use client';
import type { Metadata } from 'next';
import ErrorComponent from './ErrorComponent';

export const metadata: Metadata = {
  title: 'Error — Winteria App'
};

export default function Error({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body>
        <ErrorComponent error={error} reset={reset} />
      </body>
    </html>
  );
}
